


const Spinner = () => {
  return (
      <span className='Spinning my-3'/>
  )
}
export default Spinner;